export { AuthModal } from './ui/AuthModal/AuthModal';

export { authReducer, openAuthModal } from './model/slice/authSlice';
